module.exports = __webpack_public_path__ + "img/evn16.cb08abbd.jpg";